import { BACK_URL_SESSION_KEY } from '@/lib/backUrl'

export function readSessionString(key: string, fallback = ''): string {
  try {
    return sessionStorage.getItem(key) ?? fallback
  } catch {
    return fallback
  }
}

export function writeSessionString(key: string, value: string) {
  try {
    sessionStorage.setItem(key, value)
  } catch {}
}

export function readSessionJson<T>(key: string, fallback: T): T {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return fallback
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

export function writeSessionJson(key: string, value: unknown) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch {}
}

export function clearSession() {
  try {
    const backUrl = sessionStorage.getItem(BACK_URL_SESSION_KEY)
    sessionStorage.clear()
    if (backUrl) {
      sessionStorage.setItem(BACK_URL_SESSION_KEY, backUrl)
    }
  } catch {}
}
